// common
import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';

// redux
import { Provider } from 'react-redux';
import store from './redux/store';

// common JS
import loginCheckOnEnter from './commonJS/loginCheckOnEnter';

// skyfamily
import SkyFamily from './skyfamily/routes/SkyFamily';
import LoginCt from './skyfamily/routes/login/LoginCt';
// import SkyFamilyDashboardCt from './skyfamily/routes/dashboard/SkyFamilyDashboardCt';
import LoggedInChecker from './skyfamily/routes/LoggedInChecker';

// salesky
import SaleSky from './salesky/routes/SaleSky';
// import WorkLogDataTableCt from './salesky/routes/workLog/WorkLogDataTableCt';
// import WorkLogModalCt from './salesky/routes/workLog/WorkLogModalCt';

// skyfamily.com/product name

// IndexRoute為上一層path的預設child
// 使用onEnter方式可以在mount元件之前判斷並做處理，比在元件的willMount中判斷好

// salesky News
import NewsDataTableCt from './salesky/routes/news/NewsDataTableCt';
import NewsModalCt from './salesky/routes/news/NewsModalCt';

// // salesky Calendar
// import CalendarCt from './salesky/routes/calendar/CalendarCt';
// import CalendarModalCt from './salesky/routes/calendar/CalendarModalCt';

// // salesky Customer
// import CustomerDataTableCt from './salesky/routes/customer/CustomerDataTableCt';
// import CustomerModalCt from './salesky/routes/customer/CustomerModalCt';

// // SalesCases
// import SalesCasesTableCt from './salesky/routes/salesCases/SalesCasesTableCt';
// import SalesCasesModalCt from './salesky/routes/salesCases/SalesCasesModalCt';

// // ShippingRecords
// import ShippingRecordsTableCt from './salesky/routes/shippingRecords/ShippingRecordsTableCt';
// import ShippingRecordsModalCt from './salesky/routes/shippingRecords/ShippingRecordsModalCt';

// salesky Product
import ProductCt from './salesky/routes/product/ProductCt';
import ProductModalCt from './salesky/routes/product/ProductModalCt';

// // KM
// import KMCt from './salesky/routes/km/KMCt';
// import KMModalCt from './salesky/routes/km/KMModalCt';

// // PartsBase
// import PartsBaseTableCt from './salesky/routes/partsBase/PartsBaseTableCt';
// import PartsBaseModalCt from './salesky/routes/partsBase/PartsBaseModalCt';

// salesky report
import ReportCt from './salesky/routes/report/ReportCt';

// // salesky mediaCloud
// import MediaCloudCt from './salesky/routes/mediaCloud/MediaCloudCt';

// admin
import AdminDataTable from './salesky/routes/admin/AdminDataTable';
import AdminCt from './salesky/routes/admin/AdminCt';
import AdminRoleDataTable from './salesky/routes/admin/AdminRoleDataTable';
import AdminRoleCt from './salesky/routes/admin/AdminRoleCt';
import AdminManageAccountDataTable from './salesky/routes/admin/AdminManageAccountDataTable';
import AdminManageAccountCt from './salesky/routes/admin/AdminManageAccountCt';
import AdminManageAccountAuthorityCt from './salesky/routes/admin/AdminManageAccountAuthorityCt';
import AdminUserCompanyInfo from './salesky/routes/admin/AdminUserCompanyInfo';
// import AdminUserCompanyInfoCt from './salesky/routes/admin/AdminUserCompanyInfoCt';

// online repair
// import OnlineRepairDataTable from './salesky/routes/online_repair/OnlineRepairDataTable'
// import OnlineRepairCt from './salesky/routes/online_repair/OnlineRepairCt'
import OnlineRepairDiscussCt from './salesky/routes/online_repair/OnlineRepairDiscussCt'
// import OnlineRepairTektroDataTable from './salesky/routes/online_repair/OnlineRepairTektroDataTable'
// import OnlineRepairTektroCt from './salesky/routes/online_repair/OnlineRepairTektroCt'
import OnlineRepairServiceDataTable from './salesky/routes/online_repair/OnlineRepairServiceDataTable'
import OnlineRepairServiceCt from './salesky/routes/online_repair/OnlineRepairServiceCt'

// newAdmin
import NewAdminCt from './salesky/routes/newAdmin/NewAdminCt';
import UserAccountModalCt from './salesky/routes/newAdmin/UserAccountModalCt';
import SimpleModalCt from './salesky/routes/newAdmin/SimpleModalCt';
import CompanyIntroductionModalCt from './salesky/routes/newAdmin/CompanyIntroductionModalCt';

// formList
import formQuotationTableCt from './salesky/routes/formList/formQuotationTableCt';
import formQuotationModalCt from './salesky/routes/formList/formQuotationModalCt'
// import formCostTableCt from './salesky/routes/formList/formCostTableCt';
// import formMarginTableCt from './salesky/routes/formList/formMarginTableCt';
// import formOrderTableCt from './salesky/routes/formList/formOrderTableCt';
// import formGoodsTableCt from './salesky/routes/formList/formGoodsTableCt';
// import formLadingTableCt from './salesky/routes/formList/formLadingTableCt';
// import formInvoiceTableCt from './salesky/routes/formList/formInvoiceTableCt';
// import formWarehouseTableCt from './salesky/routes/formList/formWarehouseTableCt';


// 先暫時跳過skyfamily dashboard，直接key /login or /salesky的架構
// 在router底下的route中指定的component都會接收到router相關的props
// 例如route, router, location
render((
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/" component={SkyFamily}>
        <Route path="login" component={LoginCt} onEnter={() => { loginCheckOnEnter(1); }} />
        <Route component={LoggedInChecker} onEnter={path => { loginCheckOnEnter(0, path.location.pathname); }}>
          {/*<IndexRoute component={ SkyFamilyDashboardCt } />*/}
          <Route path="salesky" component={SaleSky}>
            <Route path="news" component={NewsDataTableCt} >
              <Route path="create" type="add" component={NewsModalCt} />
              <Route path=":newsId" type="edit" component={NewsModalCt} />
            </Route>
            {/* <Route path="calendar" component={CalendarCt}>
              <Route path="create" component={CalendarModalCt} />
              <Route path=":calendarId" component={CalendarModalCt} />
            </Route>
            <Route path="work-log" component={WorkLogDataTableCt}>
              <Route path="create" component={WorkLogModalCt} />
              <Route path=":worklogId" component={WorkLogModalCt} />
            </Route>
            <Route path="customer" component={CustomerDataTableCt}>
              <Route path="create" component={CustomerModalCt} />
              <Route path=":companyId" component={CustomerModalCt} />
            </Route>
            <Route path="sales-cases" component={SalesCasesTableCt}>
              <Route path="create" component={SalesCasesModalCt} />
              <Route path=":caseId" component={SalesCasesModalCt} />
            </Route>
            <Route path="shipping-records" component={ShippingRecordsTableCt}>
              <Route path="create" component={ShippingRecordsModalCt} />
              <Route path=":recordId" component={ShippingRecordsModalCt} />
            </Route> */}
            <Route path="product" component={ProductCt}>
              <Route path="create" component={ProductModalCt} />
              <Route path=":productId" component={ProductModalCt} />
            </Route>
            {/* <Route path="km" component={KMCt}>
              <Route path="create" component={KMModalCt} />
              <Route path=":productId" component={KMModalCt} />
            </Route> */}
            <Route path="online-repair-service" component={OnlineRepairServiceDataTable} >
              <Route path="create" type="add" component={OnlineRepairServiceCt} />
              <Route path=":id" type="edit" component={OnlineRepairServiceCt} />
              <Route path="discuss/:repair_id" component={OnlineRepairDiscussCt} />
            </Route>
            {/* <Route path="parts-base" component={PartsBaseTableCt}>
              <Route path="create" component={PartsBaseModalCt} />
              <Route path=":partId" component={PartsBaseModalCt} />
            </Route>
            <Route path="media-cloud" component={MediaCloudCt} >
              <Route path=":folderId" component={MediaCloudCt} />
            </Route> */}
            <Route path="form-quotation" component={formQuotationTableCt} >
              <Route path="create" type="add" component={formQuotationModalCt} />
              <Route path=":id" type="edit" component={formQuotationModalCt} />
              {/* <Route path="discuss/:repair_id" component={OnlineRepairDiscussCt} /> */}
            </Route>
            <Route path="report" component={ReportCt} />
            {/* <Route path="form-cost" component={formCostTableCt} />
            <Route path="form-margin" component={formMarginTableCt} />
            <Route path="form-order" component={formOrderTableCt} />
            <Route path="form-goods" component={formGoodsTableCt} />
            <Route path="form-lading" component={formLadingTableCt} />
            <Route path="form-invoice" component={formInvoiceTableCt} />
            <Route path="form-warehouse" component={formWarehouseTableCt} /> */}

            <Route path="new-admin" component={NewAdminCt}>
              <Route path="group-work-log">
                <Route path="work-nature">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="work-progress">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                {/* <Route path="work-log-edit-time-setting">
                  <Route path="create" component={ SimpleModalCt } />
                  <Route path=":itemId" component={ SimpleModalCt } />
                </Route> */}
                <Route path="project-progress">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>
              <Route path="group-company-info">
                <Route path="company-introduction">
                  <Route path="create" component={CompanyIntroductionModalCt} />
                  <Route path=":itemId" component={CompanyIntroductionModalCt} />
                </Route>
              </Route>
              <Route path="group-user">
                <Route path="user-account">
                  <Route path="create" component={UserAccountModalCt} />
                  <Route path=":itemId" component={UserAccountModalCt} />
                </Route>
                <Route path="user-group">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="user-role">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>

              <Route path="group-company">
                <Route path="company-zone">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="company-industry">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="company-trade">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>

              <Route path="group-news">
                <Route path="news-type">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>

              <Route path="group-media-cloud">
                <Route path="media-cloud-file-attribute">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="media-cloud-file-attribute-value">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>

              <Route path="group-repair-service">
                <Route path="supervisor-evaluation">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-area">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-status">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-form-type">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-warranty-type">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-product-from">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-service-type">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-owner-judgement">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-currency">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-service-satisfaction">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
                <Route path="repair-issue-type">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>

              <Route path="group-system-environment">
                <Route path="system-parameter-setting">
                  <Route path="create" component={SimpleModalCt} />
                  <Route path=":itemId" component={SimpleModalCt} />
                </Route>
              </Route>
            </Route>


            <Route path="admin/UserGroup" category="UserGroup" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/Zone" category="Zone" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/Industry" category="Industry" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/Trade" category="Trade" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/WorkNature" category="WorkNature" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/ProgressStatus" category="ProgressStatus" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/ProjectProgress" category="ProjectProgress" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/NewsType" category="NewsType" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/FileProperty" category="FileProperty" component={AdminDataTable}>
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/FilePropertyValue" category="FilePropertyValue" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/FormStatus" category="FormStatus" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>
            <Route path="admin/FormType" category="FormType" component={AdminDataTable}>
              <Route path="create" type="add" component={AdminCt} />
              <Route path=":id" type="edit" component={AdminCt} />
            </Route>

            <Route path="admin/Role" category="Role" component={AdminRoleDataTable}>
              <Route path="create" type="add" component={AdminRoleCt} />
              <Route path=":id" type="edit" component={AdminRoleCt} />
            </Route>
            <Route path="admin/ManageAccount" category="ManageAccount" component={AdminManageAccountDataTable}>
              <Route path="create" type="add" component={AdminManageAccountCt} />
              <Route path=":email" type="edit" component={AdminManageAccountCt} />
              <Route path="authority/:user_id" type="edit" component={AdminManageAccountAuthorityCt} />
            </Route>
            <Route path="admin/UserCompanyInfo" category="UserCompanyInfo" component={AdminUserCompanyInfo} />

            {/*<Route path="online-repair" component={ OnlineRepairDataTable } >
              <Route path="create" type="add" component={ OnlineRepairCt } />
              <Route path=":id" type="edit" component={ OnlineRepairCt } />
              <Route path="discuss/:repair_id" component={ OnlineRepairDiscussCt } />
            </Route>*/}

          </Route>
        </Route>
      </Route>
    </Router>
  </Provider>
), document.getElementById('root'));

// skyfamily 標準架構

// render((
//   <Router history={ browserHistory }>
//     <Route path="/" component={ SkyFamily }>
//       <Route path="login" component={ LoginCt } onEnter={ () => {loginCheckOnEnter('/')}} />
//       <Route component={ LoggedInChecker } onEnter={ () => {loginCheckOnEnter('','/login')}}>
//         <IndexRoute component={ FamilyDashboardCt } />
//         <Route path="salesky" component={ SaleSky }>
//         </Route>
//       </Route>
//     </Route>
//   </Router>
// ),document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js